<template>
  <b-form @submit.prevent="$emit('submit')">
    <page-header :title="campania.nombre" subtitle="Campaña" back-to="/campanias" />

    <b-form-group label="Nombre">
      <b-form-input required type="text" v-model="campania.nombre" placeholder="Nombre de la campaña" />
    </b-form-group>
    <b-form-group label="Duracion de contrato por defecto">
      <b-form-select v-model="campania.duracionContratoDefault" required>
        <b-form-select-option disabled selected value="">
          Seleccione duracion del contrato por defecto
        </b-form-select-option>
        <b-form-select-option
          v-for="duracionContrato in duracionesContrato"
          :key="duracionContrato.id"
          :value="duracionContrato.id"
        >
          {{ duracionContrato.nombre }}
        </b-form-select-option>
      </b-form-select>
    </b-form-group>
    <b-form-checkbox switch size="lg" v-model="campania.forzarProyectoSaas"> Forzar proyecto SaaS </b-form-checkbox>

    <b-row class="mt-4">
      <b-col v-for="(descuento, index) in descuentos" md="3" :key="index">
        <b-form-group :label="'Descuento ' + descuento.nombre">
          <b-form-input v-model="descuento.descuento" type="number" min="0" placeholder="Porcentaje de descuento" />
        </b-form-group>
      </b-col>
    </b-row>

    <botonera-edicion url-cancelar="/campanias" />
  </b-form>
</template>
<script>
import * as duracionesContratoApi from "@/services/duracionesContrato";

export default {
  props: {
    campania: {
      type: Object,
      required: true,
    },
    descuentos: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      duracionesContrato: [],
    };
  },
  mounted() {
    this.cargarDuracionesContrato();
  },
  methods: {
    async cargarDuracionesContrato() {
      this.duracionesContrato = await duracionesContratoApi.listar();
    },
  },
};
</script>
